import {configTC} from "../../constant/initDrawing";
import MainTCWrapper from "../../components/live2/tc/MainTCWrapper";

const config = {
    ...configTC,
    type: "tn"
}

const Live2TNBlackPage = () => {
    return <MainTCWrapper config={config}/>
}

export default Live2TNBlackPage;